module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-cols-num clearfix"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('span', {
    staticClass: "down",
    class: {
      'down-disabled': _vm.Num <= 1
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.down()
      }
    }
  }, [_vm._v("-\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Num >= _vm.limit ? _vm.limit : _vm.Num),
      expression: "Num>=limit?limit:Num"
    }],
    class: {
      show: _vm.show
    },
    attrs: {
      "type": "text",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.Num >= _vm.limit ? _vm.limit : _vm.Num)
    },
    on: {
      "blur": function($event) {
        return _vm.blur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Num >= _vm.limit ? _vm.limit : _vm.Num = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    ref: "ul"
  }, _vm._l((_vm.numList), function(i) {
    return _c('li', {
      key: i
    }, [_vm._v(_vm._s(i))])
  }), 0)]), _vm._v(" "), _c('span', {
    staticClass: "up",
    class: {
      'up-disabled': _vm.Num >= _vm.limit
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.up()
      }
    }
  }, [_vm._v("+")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-303f7d96","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buynum.vue
// module id = 616
// module chunks = 0